var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "61px",
    height: "61px",
    viewBox: "0 0 61 61",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Images / Success Check") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u2705-\\uD83C\\uDF93-Trivia",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trivia-Question-Answer-Correct-Percentages",
    transform: "translate(-303.000000, -81.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(303.000000, 81.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Partial-Timer",
    stroke: "#50BB32",
    strokeWidth: 8,
    fill: "#FFFFFF",
    cx: 26.5,
    cy: 26.5,
    r: 26.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Square-Check",
    stroke: "none",
    fill: "#50BB32",
    points: "22.6618056 35.3104167 14 26.6472222 15.9736111 24.675 22.6618056 31.3638889 37.0270833 17 39 18.9736111"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/green-check.5a573e8f3efb1d791a420b9bfb4acc3d.svg";
export { ForwardRef as ReactComponent };